import Select from './Select.js';
export { default } from './Select.js';
//# sourceMappingURL=index.js.map
